(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/video-analysis-player/assets/javascripts/video-analysis-player.js') >= 0) return;  svs.modules.push('/components/tipsen/video-analysis-player/assets/javascripts/video-analysis-player.js');
"use strict";


const _React = React,
  useCallback = _React.useCallback,
  useMemo = _React.useMemo;
const _ReactRedux = ReactRedux,
  useSelector = _ReactRedux.useSelector,
  useDispatch = _ReactRedux.useDispatch;
const _svs$ui = svs.ui,
  ReactIcon = _svs$ui.ReactIcon,
  ReactIconButton = _svs$ui.ReactIconButton;
const VisibilityWrapper = svs.components.lbUi.visibilityWrapper.VisibilityWrapper;
const clx = svs.components.lbUtils.clx;
const VideoPlayer = svs.components.video_player.VideoPlayer;
const selectCurrentVideo = svs.components.tipsen.store.reducers.videoAnalysesSlice.selectors.selectCurrentVideo;
const _svs$components$tipse = svs.components.tipsen.store.reducers.videoAnalysesSlice.actions,
  clearCurrentVideo = _svs$components$tipse.clearCurrentVideo,
  updatePlaybackState = _svs$components$tipse.updatePlaybackState;
const _svs$components$tipse2 = svs.components.tipsen.videoAnalysisPlayer,
  createInitialPlaybackState = _svs$components$tipse2.createInitialPlaybackState,
  useVideoLoader = _svs$components$tipse2.useVideoLoader,
  usePlayerPolling = _svs$components$tipse2.usePlayerPolling;

const VideoAnalysisPlayer = _ref => {
  let _ref$easeInOut = _ref.easeInOut,
    easeInOut = _ref$easeInOut === void 0 ? false : _ref$easeInOut;
  const dispatch = useDispatch();
  const currentVideo = useSelector(selectCurrentVideo);

  const _useVideoLoader = useVideoLoader(currentVideo, dispatch),
    loadedVideo = _useVideoLoader.loadedVideo,
    hasError = _useVideoLoader.hasError,
    currentVideoRef = _useVideoLoader.currentVideoRef;
  const _usePlayerPolling = usePlayerPolling(loadedVideo, currentVideo, currentVideoRef, dispatch),
    isPlaying = _usePlayerPolling.isPlaying;
  const handleClearVideo = useCallback(() => {
    dispatch(updatePlaybackState(createInitialPlaybackState()));
    dispatch(clearCurrentVideo());
  }, [dispatch]);

  const isVisible = useMemo(() => !easeInOut || Boolean(currentVideo) || hasError, [easeInOut, currentVideo, hasError]);

  const videoTitle = useMemo(() => (currentVideo === null || currentVideo === void 0 ? void 0 : currentVideo.description) || (currentVideo === null || currentVideo === void 0 ? void 0 : currentVideo.title), [currentVideo === null || currentVideo === void 0 ? void 0 : currentVideo.description, currentVideo === null || currentVideo === void 0 ? void 0 : currentVideo.title]);
  return React.createElement(VisibilityWrapper, {
    className: "pg_video_analysis_player",
    isVisible: isVisible
  }, hasError && React.createElement("div", {
    className: "pg_video_analysis_player__error_message"
  }, "Error loading video."), !hasError && loadedVideo && React.createElement("section", {
    "aria-label": "Videoanalys ".concat(videoTitle),
    className: clx('pg_video_analysis_player__video_details', {
      'pg_video_analysis_player__video_details--playing': isPlaying
    })
  }, React.createElement(VideoPlayer, {
    jsonLDTags: loadedVideo === null || loadedVideo === void 0 ? void 0 : loadedVideo.jsonLDTags,
    src: loadedVideo === null || loadedVideo === void 0 ? void 0 : loadedVideo.src,
    title: loadedVideo === null || loadedVideo === void 0 ? void 0 : loadedVideo.title,
    videoId: loadedVideo === null || loadedVideo === void 0 ? void 0 : loadedVideo.videoId
  }), React.createElement("div", {
    className: "pg_video_analysis_player__video_title"
  }, videoTitle), React.createElement(ReactIconButton, {
    "aria-label": "St\xE4ng videoanalys",
    className: "pg_video_analysis_player__clear_video_button no_print",
    onClick: handleClearVideo
  }, React.createElement(ReactIcon, {
    color: "icon",
    icon: "close",
    size: "300"
  }))));
};
setGlobal('svs.components.tipsen.videoAnalysisPlayer', {
  VideoAnalysisPlayer
});

 })(window);